// extracted by mini-css-extract-plugin
export var cardHeader = "_i4-0";
export var reorderHandle = "_i4-3";
export var titleArea = "_i4-1";
export var titleAreaWithHandle = "_i4-2";